import { HttpResponse } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FileDownloadService } from '@services/file-download.service';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import { FilenameParser } from '@utils/FilenameParser';
import { ListarPedidosService } from 'src/app/services/listar-pedidos.service';
import { ToastrService } from 'ngx-toastr';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {interval, Subscription} from 'rxjs';
import {exhaustMap, retry, take} from 'rxjs/operators';
import {ModalLoadingComponent} from 'src/app/components/modal-loading/modal-loading.component';
import { VtToasterService } from '@services/vt-toaster.service';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertCancelarPedidoComponent } from './alert-cancelar-pedido/alert-cancelar-pedido.component';
import { AlertImprimirReciboComponent } from './alert-imprimir-recibo/alert-imprimir-recibo.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { ResumoComponent } from './resumo/resumo.component';
import { TaxaOperadoraComponent } from './taxa-operadora/taxa-operadora.component';
import { ListaUsuariosComponent } from './lista-usuarios/lista-usuarios.component';
import { RecargaCertaComponent } from './recarga-certa/recarga-certa.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CnpjPipe } from '../../pipes/cnpj.pipe';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-listar-pedidos-detalhes',
    templateUrl: './listar-pedidos-detalhes.component.html',
    styleUrls: ['./listar-pedidos-detalhes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, AlertCancelarPedidoComponent, AlertImprimirReciboComponent, BreadcrumbComponent, NgClass, ResumoComponent, TaxaOperadoraComponent, ListaUsuariosComponent, RecargaCertaComponent, FooterComponent, AsyncPipe, CnpjPipe, UsuarioPermissaoPipe]
})
export class ListarPedidosDetalhesComponent implements OnInit {
  public statusPedido: string;
  public idPedido: string;
  public dadosResumoPedido: any = null;
  public dadosTaxasOperadorasPedido: any = null;
  public dadosListaUsuariosPedido: any = null;
  public cancelarPedido: any = undefined;
  public recargaCerta = false;
  public pedidoPapel = false;
  public processado = false;
  public idEmpresa : any;
  subscriptions = new Subscription();
  toasterTimeout = 5_000;
  dialogRef: MatDialogRef<ModalLoadingComponent>;
  idDownload: any;

  // ALERTS
  public showAlertImprimirRecibo = false;

  public showAlertCancelarPedido = false;

  constructor(
    public rotaAtiva: ActivatedRoute,
    private readonly service: ListarPedidosService,
    private readonly rota: Router,
    public usuarioPermissaoService: UsuarioPermissaoService,
    private readonly dialog: MatDialog,
    private readonly Toastr: ToastrService,
    private readonly toastr: VtToasterService
  ) {}

  ngOnInit(): void {
    this.rotaAtiva.queryParams.subscribe((data: any) => {
      this.idPedido = data.idPedido;
      this.idEmpresa = data.idEmpresa;
      this.consultaResumoPedido(this.idPedido);
    });
  }

  consultaResumoPedido(idPedido: string) {
    this.service.getResumoPedido(idPedido, this.idEmpresa)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status == 'OK') {
          this.dadosResumoPedido = response.response;
          this.statusPedido = this.dadosResumoPedido.status;
          this.recargaCerta = this.dadosResumoPedido?.tipoPedido?.indexOf('RECARGA CERTA') > -1;
          this.processado = this.dadosResumoPedido?.statusRecargaCerta?.toUpperCase().indexOf('PROCESSADO') > -1;
          this.pedidoPapel = this.dadosResumoPedido?.tipoPedido === 'VALE PAPEL';
        } else {
          this.dadosResumoPedido = false;
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.dadosResumoPedido = false;
      }
    });
  }

  consultaTaxasOperadoresPedido() {
    if (!this.dadosTaxasOperadorasPedido) {
      this.service.getTaxasOperadoraPedido(this.idPedido)
      .pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.status == 'OK') {
            this.dadosTaxasOperadorasPedido = response.response;
          }
          if (response.status == 'NOK') {
            this.dadosTaxasOperadorasPedido = 404;
          }
        },
        error: (erro: any) => {
          console.error(erro);
          this.dadosTaxasOperadorasPedido = false;
        }
      });
    }
  }

  consultaListaUsuariosPedido() {
    if (!this.dadosListaUsuariosPedido) {
      this.service.getListaUsuariosPedido(this.idPedido).pipe(take(1))
      .subscribe({
        next: (response: any) => {
          if (response.status == 'OK' && response.response?.length) {
            this.dadosListaUsuariosPedido = response.response;
          } else {
            this.dadosListaUsuariosPedido = false;
          }
        },
        error: (erro: any) => {
          console.error(erro);
          this.dadosListaUsuariosPedido = false;
        }
      });
    }
  }

  exibirAlertCancelarPedido() {
    this.showAlertCancelarPedido = true;
  }

  eventoAlertCancelarPedido(event: any) {
    this.showAlertCancelarPedido = false;
  }

  // AQUI FAZ O CANCELAMENTO DO PEDIDO ENVIANDO PRA API, as funções de cima são apenas o visual
  eventoAlertConfirmarCancelamento(event: any) {
    this.cancelarPedido = null;
    const arrayPedido = [this.idPedido];

    this.service.cancelarPedidos(arrayPedido)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        if (response.status == 'OK') {
          this.cancelarPedido = true;
          setTimeout(() => {
            this.rota.navigate(['listar-pedidos']);
          }, 5000);
        }
      },
      error: (erro: any) => {
        console.error(erro);
        this.cancelarPedido = false;
      }
    });
  }

  fecharAlertImprimirRecibo() {
    this.showAlertImprimirRecibo = false;
  }

  imprimirReciboPdf() {
    this.showAlertImprimirRecibo = true;
  }


  gerarRelatorioPdf() {

    this.Toastr.info('Realizando download do relatório Pdf');

    this.service.gerarRelatorioPdf(this.idPedido)
    .pipe(take(1))
    .subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        this.Toastr.clear();
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'),
          'Arquivo.pdf',
        );
        FileDownloadService.download([body], filename);
      },
      error: (error) => {
        this.Toastr.clear();
        console.error(error);
        this.Toastr.error('Erro ao baixar o relatório Pdf, por favor tente mais tarde.');
      }
    });
  }

  gerarRelatorioXls() {

    this.Toastr.clear();

    this.openLoading('Realizando download do relatório XLS!', 'Seu relatório estará pronto em alguns <span style="font-weight: 600;">minutos.</span>',
      '<span style="font-weight: 600;">Aguarde seu arquivo</span> ser baixado automaticamente.', '633px', true, false, ''
    );

    this.service.gerarRelatorioXls(this.idEmpresa, this.idPedido)
    .pipe(take(1))
    .subscribe({
      next: (response: any) => {
        this.idDownload = response.response.idDownload;
        this.statusArquivo('xls', this.idEmpresa);
      },
      error: (erro: any) => {
        this.openLoadingErro(erro);
      }
    });
  }

  goBackPage() {
    window.history.back();
  }

  getRelatorio() {

    this.Toastr.info('Realizando download do relatório Rc');

    this.service.getRelatorio(this.idPedido)
    .pipe(take(1))
    .subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        this.Toastr.clear();
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'),
          'Arquivo.xls',
        );
        FileDownloadService.download([body], filename);
      },
      error: (error) => {
        console.error(error);
        this.Toastr.clear();
        this.Toastr.error('Erro ao baixar o relatório Rc, por favor tente mais tarde.');
      }
    });
  }

  openLoading(title: string, text1: string, text2: string, width: string, disableClose: boolean, erroLoading: boolean, textButton: string
  ) {
    this.fecharLoading();

    this.dialogRef = this.dialog.open(ModalLoadingComponent, {
      disableClose,
      hasBackdrop: true,
      data: {erroLoading, title, text1, text2, textButton},
      width
    });
  }

  private openLoadingErro(erro: any) {
    if (erro.status === 404 && erro.message) {
      this.openLoading('Erro ao baixar relatório:', 'Ocorreu erro durante o processamento do relatório.',
        '', '633px', false, true, 'Entendi'
      );
    } else {
      this.openLoading('Ops, algo deu errado :(', 'Não conseguimos baixar o relatório solicitado, tente novamente.',
        '', '533px', false, true, 'Tentar Novamente'
      );
    }
  }

  fecharLoading() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  private statusArquivo(tipoArquivo: string, empresaId: number) {
    const subscription = interval(5000)
      .pipe(
        exhaustMap(() => this.service.getFileGenerationStatus(this.idDownload, tipoArquivo, empresaId)
          .pipe(retry(10)),
        ),
      )
      .subscribe({
        next: ({response}: any) => {
          if (response?.status === 'FINALIZADO') {
            this.baixarArquivo(response?.urlDownload, 'relatorio.xls');
            subscription.unsubscribe();
            this.fecharLoading();
          } else if (response?.status !== 'EM_ANDAMENTO') {
            this.toastr.error('Erro gerando o relatório.', 'Tempo excedido para gerar o relatório solicitado:', this.toasterTimeout);
            subscription.unsubscribe();
            this.fecharLoading();
          }
        },
        error: (error) => {
          this.toastr.error('Não conseguimos baixar o informe solicitado, tente novamente.', 'Ops, algo deu errado :(', this.toasterTimeout);
        }
      });
    this.subscriptions.add(subscription);
  }

  private baixarArquivo(url: string, nomeArquivo: string) {
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}
